import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest"
import SettingList from "./SettingList"
import SettingEdit from "./SettingEdit"

export default {
  list: SettingList,
  edit: SettingEdit,
  icon: SettingsSuggestIcon,
}
